import script from "./DetailReport.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__